import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';

import './components/uploadFile.component.js';
import './components/animations.component.js';
import './components/inputs.component.js';
import './components/meta/select.component.js';
import './components/header.component.js';

/*import './components/sw-vacancies.component.js';*/

import './components/validation.component.js';

import './libs/countUp.lib.js';